
export const API_KEY = process.env.REACT_APP_OPENAI_API_KEY// API Key from your environment
export const API_URL = 'https://api.openai.com/v1/chat/completions';

export const PROMPT_MODEL = {

    // GPT35_16K_0613: "gpt-3.5-turbo-16k-0613",
    // GPT35_16K: "gpt-3.5-turbo-16k",
    GPT4o: "gpt-4o",
    TEMP: 0.1,
    MAX_TOKENS: 2050,
};


export const removeTags = (html: string): string => {
    const parser = new DOMParser();

    // Wrap the HTML in a container to allow for easy parsing
    const wrappedHtml = `<body>${html}</body>`;
    const doc = parser.parseFromString(wrappedHtml, 'text/html');

    // Remove the title, link, and meta tags
    const titleElement = doc.querySelector('title');
    if (titleElement) {
        const newH2 = doc.createElement('h5');
        newH2.textContent = titleElement.textContent || ""; // Set the h2 text to the title content
        titleElement.replaceWith(newH2); // Replace the title tag with the new h2 element
    }
    const linkElement = doc.querySelector('link[rel="canonical"]');
    if (linkElement) {
        const newA = doc.createElement('a');
        newA.href = linkElement.getAttribute('href') || ""; // Set the href attribute from the link
        newA.textContent = linkElement.getAttribute('href') // You can customize the link text as needed
        linkElement.replaceWith(newA); // Replace the link tag with the new a element
    }

    // Replace all <meta> tags with <div> tags
    doc.querySelectorAll('meta').forEach(metaTag => {
        const newDiv = doc.createElement('div');
        newDiv.textContent = metaTag.getAttribute('content') || ""; // Set the content of the div to the meta tag's content
        metaTag.replaceWith(newDiv); // Replace the meta tag with the new div element
    });

    // Collect the inner HTML of the div (excluding the removed tags)
    const cleanedHtml = doc.body.innerHTML.trim();

    // console.log("Original HTML:", html);


    return cleanedHtml; // Return the cleaned content
};

export const getTitleColor = (number: number) => {

    if (number > 60) {
        return 'danger'
    }
    if (number < 40) {
        return 'warning'
    }
    return 'success'

}

export const getDescriptionColor = (number: number) => {
    if (number > 160) {
        return 'danger'
    }
    if (number < 120) {
        return 'warning'
    }
    return 'success'

}